var CONFUSEDCMS = CONFUSEDCMS || {};

(function ($) {

    CONFUSEDCMS.setupProductTestimonials = function() {

        $('.js-product-testimonials-show-more-btn').on('click',CONFUSEDCMS.getProductTestimonials);
    };

    CONFUSEDCMS.getProductTestimonials = function() {

        var item = $('#testimonials-item'), product = $('#testimonials-product'), skip = $('#testimonials-skip'), take = $('#testimonials-take');

        if (item == null || product == null || skip == null || take == null) { return; }

        var endpoint = 'Services/ContentProvider/ContentProviderService.aspx';

        var service = new window.Confused.ServiceProxy(endpoint, 300);

        var toTake = parseInt(take.val());
        var toSkip = $('li.js-product-testimonial').length;

        var options = {
            method: 'GetProductTestimonials',
            data: '{ item: "' + item.val() + '", product:"' + product.val() + '", take:"' + toTake + '", skip:"' + toSkip + '"}'
        };

        var result = service.invoke(options);

        result.done(function(data) {

            if (data === '{}') {
                return;
            }

            var testimonials = JSON.parse(data);
            if (testimonials.length < toTake) {
                $('div.show-more-wrapper').hide();
            }

            if (testimonials.length === 0) {
                return;
            }

            renderList(testimonials);
        });
    };

    function renderList(testimonials) {

        var list = $('div.cms-content ul.unstyled-list');

        $.each(testimonials, function (i, testimonial) {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        

            list.append($('<li>', { 'class': 'js-product-testimonial' })
                .append($('<blockquote>', { itemprop: 'review', itemscope: 'itemscope', itemtype: 'http://schema.org/Review' })
                    .append($('<span>', { itemprop: 'description' }).text(testimonial.Description))
                    .append($('<footer>')
                        .append($('<div>', { 'class': 'writer clearfix test2' })
                            .append($('<img>', { 'class': 'writer__image', src: testimonial.Image.Src, alt: testimonial.Image.Alt }))
                            .append($('<b>', { 'class': 'writer__name', itemprop: 'author' }).text(testimonial.Author))
                            .append($('<p>', { itemprop: 'datePublished', content: testimonial.QuoteDate }).text(testimonial.QuoteDateSummary))
                        )
                        .append($('<span>', { 'class': testimonial.RatingClass, itemprop: 'reviewRating', itemscope: 'itemscope', itemtype: 'http://schema.org/Rating', ratingTitle: testimonial.RatingTitle })
                            .append($('<meta>', { itemprop: 'ratingValue', content: testimonial.RatingValue }))
                        )
                        .append($('<p>').text(testimonial.RatingTitle))
                    )                    
                )
            );
        });
    }

})(window.jQuery);